const isIframeResizerLoaded = function () {
	return typeof globalThis.iFrameResize === 'function';
};

const resizeIframes = function () {
	globalThis.iFrameResize({ log: false, checkOrigin: false });
};

/**
 * iframeResizer is consent-gated (functional), so it can load after this bundle, or never.
 * Script `load` events don't bubble, so listen in the capture phase until it arrives.
 */
const resizeIframesWhenLoaded = function () {
	if (isIframeResizerLoaded()) {
		resizeIframes();
		return;
	}

	const onScriptLoad = function () {
		if (!isIframeResizerLoaded()) {
			return;
		}

		globalThis.document.removeEventListener('load', onScriptLoad, true);
		resizeIframes();
	};

	globalThis.document.addEventListener('load', onScriptLoad, true);
};

let THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	(function () {
		$onReady({
			rp$, window,
			label: 'interactive_garage',
			fn: resizeIframesWhenLoaded,
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	var __CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
